__turbopack_context__.v({
  "actions": "layout-module__Tjx29W__actions",
  "brand": "layout-module__Tjx29W__brand",
  "brandBadge": "layout-module__Tjx29W__brandBadge",
  "footer": "layout-module__Tjx29W__footer",
  "footerBottom": "layout-module__Tjx29W__footerBottom",
  "footerBrand": "layout-module__Tjx29W__footerBrand",
  "footerGrid": "layout-module__Tjx29W__footerGrid",
  "footerNav": "layout-module__Tjx29W__footerNav",
  "header": "layout-module__Tjx29W__header",
  "headerScrolled": "layout-module__Tjx29W__headerScrolled",
  "headerSlot": "layout-module__Tjx29W__headerSlot",
  "logo": "layout-module__Tjx29W__logo",
  "menuButton": "layout-module__Tjx29W__menuButton",
  "mobileActions": "layout-module__Tjx29W__mobileActions",
  "mobileMenu": "layout-module__Tjx29W__mobileMenu",
  "nav": "layout-module__Tjx29W__nav",
  "socials": "layout-module__Tjx29W__socials",
});
